import React, { useEffect, useMemo, useState } from 'react'
import ModalBaseSm from '../../modals/modal-base-sm';
import FormModalCreateDispositivo from '../forms/formModalCreateDispositivo';
import { Col, Row } from 'reactstrap';
import axios from '../../../utils/axiosConfig';
import Swal from 'sweetalert2';

const ModalDispositivos = ({ bitInserts, bitEdits, bitDeletes }) => {

    const [dispositivos, setDispositivos] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [placaBusqueda, setPlacaBusqueda] = useState('');
    const [dialogOpen, setDialogOpen] = useState(false);

    const [DeviceID, setDeviceID] = useState('');
    const [fkLokCommOp, setFkLokCommOp] = useState('');
    const [fKLokProyecto, setFkLokProyecto] = useState('');
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');

    const [operators, setOperators] = useState([]);
    const [proyectos, setProyectos] = useState([]);



    const [idEdit, setIdEdit] = useState(-1);
    const [debouncedTerm, setDebouncedTerm] = useState(searchTerm);

    const handleSaveOrUpdate = ({ DeviceID, fkLokCommOp, fkLokProyecto, username, password }) => {
        if (idEdit === -1) {
            guardar({ DeviceID, fkLokCommOp, fkLokProyecto, username, password });
        } else {
            update({ DeviceID, fkLokCommOp, fkLokProyecto, username, password });
        }
    };

    const validatePlacaUnique = async (placa) => {
        console.log('Validando placa única:', placa);
        try {
            const { data } = await axios.post(
                `${process.env.REACT_APP_SERVER}/operaciones/existedevicegps`,
                { Placa: placa },
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("tkn")}`,
                    },
                    withCredentials: true,
                }
            );
            console.log('Respuesta de validación de placa:', data);
            // si el backend marca error
            if (!data?.success) {
                Swal.fire("Error", data?.message || "No se pudo validar la placa.", "error");
                return false;
            }

            if (data?.success && data?.data?.length > 0) {
                Swal.fire("Error", "La placa ya existe. Por favor, ingrese una placa única.", "error");
                return false;
            }

            return true;
        } catch (error) {
            console.log("Error al validar placa única:", error);
            Swal.fire("Error", "No se pudo validar la placa.", "error");
            return false;
        }
    };


    const listarDispositivos = () => {
        axios
            .post(
                process.env.REACT_APP_SERVER + '/operaciones/getdevicegps',
                {
                    Placa: placaBusqueda || '',
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${localStorage.getItem('tkn')}`,
                    },
                    withCredentials: true,
                }
            )
            .then(res => {
                if (res.data.success) {
                    console.log(
                        'Dispositivos obtenidos:',
                        res.data.data
                    );
                    setDispositivos(res.data.data);
                } else {
                    Swal.fire(
                        'Error',
                        'No se pudo cargar dispositivos',
                        'error'
                    );
                }
            })
            .catch(() =>
                Swal.fire(
                    'Error',
                    'Falla de red al cargar lista',
                    'error'
                )
            );
    };

    const getProyectos = () => {
        // Lógica para obtener proyectos
        axios.get(`${process.env.REACT_APP_SERVER}/operaciones/getproyectos`, {}, {
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('tkn')}` },
            withCredentials: true
        })
            .then(res => {
                if (res.data.success) {
                    console.log('Proyectos obtenidos:', res.data.data);
                    setProyectos(res.data.data);

                } else {
                    Swal.fire('Error', 'No se pudieron obtener proyectos', 'error');
                }
            })
            .catch(() => {
                Swal.fire('Error', 'Falla de red al obtener proyectos', 'error');
            });
    }
    const getOperators = () => {
        // Lógica para obtener operadores
        axios.get(`${process.env.REACT_APP_SERVER}/operaciones/getoperadorgps`, {}, {
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('tkn')}` },
            withCredentials: true
        })
            .then(res => {
                if (res.data.success) {
                    console.log('Operadores obtenidos:', res.data.data);
                    setOperators(res.data.data);
                } else {
                    Swal.fire('Error', 'No se pudieron obtener operadores', 'error');
                }
            })
            .catch(() => {
                Swal.fire('Error', 'Falla de red al obtener operadores', 'error');
            });
    }

    const editarDispositivo = item => {
        console.log('Editando dispositivo:', item);
        setDeviceID(item.DeviceID);
        setFkLokCommOp(item.FkLokCommOp);
        setFkLokProyecto(item.FKLokProyecto);
        setIdEdit(item.DeviceID);
        setUsername(item.UsuarioS);
        setPassword(item.ClaveS);
        setDialogOpen(true);
    };

    const toggleDialog = () => {
        setDialogOpen(!dialogOpen);
        limpiarCampos();
    }

    const getOperatorName = (id) => {
        if (!id) return '-';
        const op = operators.find(o => o.IdOperadorGPS === id || o.FkLokCommOp === id);
        return op?.OperadorGPS || op?.Descripcion || String(id);
    };

    const getProyectoName = (id) => {
        if (!id) return '-';
        const pr = proyectos.find(p => p.IDProyecto === id || p.FkLokProyecto === id);
        return pr?.Descripcion || pr?.Descripcion || String(id);
    };


    const guardar = ({ DeviceID, fkLokCommOp, fkLokProyecto, username, password }) => {
        console.log('Guardando nuevo dispositivo');
        console.log('Datos recibidos:', { DeviceID, fkLokCommOp, fkLokProyecto, username, password });
        if (!DeviceID.trim() || !fkLokCommOp.trim() || !fkLokProyecto.trim() || !username.trim() || !password.trim()) {
            Swal.fire(
                'Error',
                'Debe completar los campos',
                'error'
            );
            return;
        }
        const payloadCreate = {
            ID: -1,
            DeviceID: DeviceID,
            FkLokCommOp: fkLokCommOp,
            FKLokProyecto: fkLokProyecto,
            UsuarioS: username,
            ClaveS: password
        };
        console.log('Payload a subir para crear:', payloadCreate);
        validatePlacaUnique(payloadCreate.DeviceID)
        axios
            .post(
                process.env.REACT_APP_SERVER + '/operaciones/setdevicegps',
                JSON.stringify(payloadCreate),
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${localStorage.getItem('tkn')}`,
                    },
                    withCredentials: true,
                }
            )
            .then(res => {
                if (!res.data.success) {
                    Swal.fire('Error', 'No se pudo guardar', 'error');
                    return;
                }
                console.log('Dispositivo guardado:', res.data);
                Swal.fire(
                    'Éxito',
                    'Dispositivo guardado',
                    'success'
                );
                listarDispositivos();
                limpiarCampos();
                toggleDialog();
            })
            .catch(() =>
                Swal.fire('Error', 'No se pudo guardar', 'error')
            );
    };

    const update = ({ DeviceID, fkLokCommOp, fkLokProyecto, username, password }) => {
        console.log('Actualizando agencia con ID:', idEdit);
        if (!DeviceID.trim() || !fkLokCommOp.trim() || !fkLokProyecto.trim() || !username.trim() || !password.trim()) {
            Swal.fire(
                'Error',
                'Debe completar todos los campos',
                'error'
            );
            return;
        }
        const payloadUpdate = {
            ID: DeviceID,
            DeviceID: DeviceID,
            FkLokCommOp: fkLokCommOp,
            FKLokProyecto: fkLokProyecto,
            UsuarioS: username,
            ClaveS: password
        };
        console.log('Payload a subir para actualizar:', payloadUpdate);
        validatePlacaUnique(payloadUpdate.DeviceID)
        axios
            .post(
                process.env.REACT_APP_SERVER + '/operaciones/setdevicegps',
                JSON.stringify(payloadUpdate),
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${localStorage.getItem('tkn')}`,
                    },
                    withCredentials: true,
                }
            )
            .then(res => {
                if (!res.data.success) {
                    Swal.fire(
                        'Error',
                        'No se pudo actualizar',
                        'error'
                    );
                    return;
                }
                console.log('Dispositivo actualizado:', res.data);
                Swal.fire(
                    'Éxito',
                    'Dispositivo actualizado',
                    'success'
                );
                listarDispositivos();
                limpiarCampos();
                toggleDialog();
            })
            .catch(() =>
                Swal.fire(
                    'Error',
                    'No se pudo actualizar',
                    'error'
                )
            );
    };

    const limpiarCampos = () => {
        setDeviceID('');
        setFkLokCommOp('');
        setFkLokProyecto('');
        setUsername('');
        setPassword('');
        setIdEdit(-1);
    }

    const filtered = useMemo(() => {
        if (!debouncedTerm) return dispositivos;

        const term = debouncedTerm.toLowerCase();

        return dispositivos.filter(item => {
            // 1) Coincidencia en los campos del dispositivo
            const baseMatch = Object.values(item).some(val =>
                String(val || '').toLowerCase().includes(term)
            );

            // 2) Nombre del operador
            const operatorName = getOperatorName(item.FkLokCommOp);
            const operatorMatch = String(operatorName || '')
                .toLowerCase()
                .includes(term);

            // 3) Nombre del proyecto
            const proyectoName = getProyectoName(item.FkLokProyecto ?? item.FKLokProyecto);
            const proyectoMatch = String(proyectoName || '')
                .toLowerCase()
                .includes(term);

            return baseMatch || operatorMatch || proyectoMatch;
        });
    }, [dispositivos, debouncedTerm, operators, proyectos]);


    useEffect(() => {
        const handler = setTimeout(
            () => setDebouncedTerm(searchTerm.trim().toLowerCase()),
            300
        );
        return () => clearTimeout(handler);
    }, [searchTerm]);

    useEffect(() => {
        listarDispositivos();
        getProyectos();
        getOperators();
    }, []);

    useEffect(() => {
        listarDispositivos();
    }, [placaBusqueda]);

    return (
        <>

            {/* Estilos responsivos solo para este componente */}
            <style>
                {`
                            @media (max-width: 575.98px) {
                                .btn-nuevo-dispositivo {
                                    width: 100%;
                                }
                            }
                        `}
            </style>

            <Row className="mb-4 align-items-center">
                <Col sm="4">
                    <input
                        type="text"
                        className="form-input w-100"
                        placeholder="Buscar placa..."
                        value={placaBusqueda}
                        onChange={e => setPlacaBusqueda(e.target.value)}
                        style={{ height: '38px', boxSizing: 'border-box' }}
                    />
                </Col>
                <Col sm="4">
                    <input
                        type="text"
                        className="form-input w-100 mt-2 mt-sm-0"
                        placeholder="Buscar por operador / proyecto / device..."
                        value={searchTerm}
                        onChange={e => setSearchTerm(e.target.value)}
                        style={{ height: '38px', boxSizing: 'border-box' }}
                    />
                </Col>
                <Col
                    sm="4"
                    className="d-flex justify-content-center justify-content-sm-end mt-2 mt-sm-0"
                >
                    <button
                        className="Button blue btn-nuevo-dispositivo"
                        onClick={() => {
                            if (bitInserts) toggleDialog();
                        }}
                        style={{ height: '38px', minWidth: '150px' }}
                    >
                        Nuevo Dispositivo
                    </button>
                </Col>
            </Row>

            <div className="card ContainerTableMaestros">
                <div
                    className="table-responsive text-nowrap"
                    style={{ height: '300px', overflowY: 'auto' }}
                >
                    <table
                        className="table table-hover"
                        id="tabla"
                        style={{ width: '100%', overflowX: 'auto' }}
                    >
                        <thead className="FondoHeaderTabla2">
                            <tr>
                                <th style={{ color: '#ffffff', textAlign: 'center', width: '20%' }}>
                                    Device ID
                                </th>
                                <th style={{ color: '#ffffff', textAlign: 'center', width: '35%' }}>
                                    Operador
                                </th>
                                <th style={{ color: '#ffffff', textAlign: 'center', width: '35%' }}>
                                    Proyecto
                                </th>
                                <th style={{ color: '#ffffff', textAlign: 'center', width: '10%' }}>
                                    Acciones
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {filtered?.map((item, i) => (
                                <tr key={i}>
                                    <td style={{ color: '#000', textAlign: 'start' }}>
                                        {item.DeviceID || '-'}
                                    </td>
                                    <td style={{ color: '#000', textAlign: 'center' }}>
                                        {getOperatorName(item.FkLokCommOp)}
                                    </td>
                                    <td style={{ color: '#000', textAlign: 'center' }}>
                                        {getProyectoName(item.FKLokProyecto)}
                                    </td>
                                    <td style={{ textAlign: 'center' }}>
                                        <a
                                            href="#"
                                            onClick={e => {
                                                e.preventDefault();
                                                if (bitEdits) editarDispositivo(item);
                                            }}
                                        >
                                            <i
                                                className="bx bxs-pencil bx-tada"
                                                style={{ color: '#006699' }}
                                            />
                                        </a>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
            {/* MODAL */}
            <ModalBaseSm
                isOpen={dialogOpen}
                title={
                    idEdit === -1
                        ? 'Crear dispositivo'
                        : 'Editar dispositivo'
                }
                onClose={toggleDialog}
                childComponent={
                    <FormModalCreateDispositivo
                        onSave={handleSaveOrUpdate}
                        initialData={{ DeviceID, fkLokCommOp, fKLokProyecto, ID: idEdit, username, password }}
                        operators={operators}
                        proyectos={proyectos}
                    />
                }
            />
        </>
    )
}

export default ModalDispositivos
